var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaritySortByLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_113_203)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7828 10.8327H6.21615C5.99513 10.8327 5.78317 10.7449 5.62689 10.5886C5.47061 10.4323 5.38281 10.2204 5.38281 9.99935C5.38281 9.77834 5.47061 9.56637 5.62689 9.41009C5.78317 9.25381 5.99513 9.16602 6.21615 9.16602H23.7828C24.0038 9.16602 24.2158 9.25381 24.3721 9.41009C24.5283 9.56637 24.6161 9.77834 24.6161 9.99935C24.6161 10.2204 24.5283 10.4323 24.3721 10.5886C24.2158 10.7449 24.0038 10.8327 23.7828 10.8327Z",
    fill: "#FF7A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6411 15.8327H6.21615C5.99513 15.8327 5.78317 15.7449 5.62689 15.5886C5.47061 15.4323 5.38281 15.2204 5.38281 14.9993C5.38281 14.7783 5.47061 14.5664 5.62689 14.4101C5.78317 14.2538 5.99513 14.166 6.21615 14.166H17.6411C17.8622 14.166 18.0741 14.2538 18.2304 14.4101C18.3867 14.5664 18.4745 14.7783 18.4745 14.9993C18.4745 15.2204 18.3867 15.4323 18.2304 15.5886C18.0741 15.7449 17.8622 15.8327 17.6411 15.8327Z",
    fill: "#FF7A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4495 20.8327H6.21615C5.99513 20.8327 5.78317 20.7449 5.62689 20.5886C5.47061 20.4323 5.38281 20.2204 5.38281 19.9993C5.38281 19.7783 5.47061 19.5664 5.62689 19.4101C5.78317 19.2538 5.99513 19.166 6.21615 19.166H11.4495C11.6705 19.166 11.8825 19.2538 12.0387 19.4101C12.195 19.5664 12.2828 19.7783 12.2828 19.9993C12.2828 20.2204 12.195 20.4323 12.0387 20.5886C11.8825 20.7449 11.6705 20.8327 11.4495 20.8327Z",
    fill: "#FF7A00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_113_203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaritySortByLine);
export default __webpack_public_path__ + "static/media/clarity_sort-by-line.31a0b9a2b9632d1973b45a5d2b3f35ee.svg";
export { ForwardRef as ReactComponent };